/*
 * � 2020 Microsoft. All rights reserved.
 */

define('Managers/ScaleManager',['lodash'],
	function (_) {
		var ScaleManager = {
			elements: {
				WidthBase: [],
				HeightBase: [],
				Full: []
			},
			prevWidth: 0,
			prevHeight: 0,
			scaleFactorX: 0,
			scaleFactorY: 0,
			scaleFactor: 0,
			slideOutMenuBreakPoint: 640,
			addElement: function (element, options) {
				if (this.elements[options.scaleChangeSource].indexOf(element) === -1 && element.handleResize) {
					this.elements[options.scaleChangeSource].push(element);
					element.handleResize();
				}
			},
			removeElement: function (element) {
				var index = this.elements['Full'].indexOf(element);
				if (index === -1) return;
				this.elements['Full'].splice(index, 1);
			},
			handleResize: function (width, height) {
				this.prevWidth = this.width;
				this.prevHeight = this.height;
				this.width = width;
				this.height = height;
				this.scaleFactorX = width / 1920;
				this.scaleFactorY = height / 1080;
				var elements = [];
				if (this.width !== this.prevWidth) {
					elements = [].concat(this.elements['WidthBase'], this.elements['Full']);
				}
				if (this.height !== this.prevHeight) {
					elements = [].concat(this.elements['HeightBase'], this.elements['Full']);
				}
				elements.forEach(function (element) {
					ScaleManager.resizeElement(element);
				});
			},
			resizeElement: function (element) {
				element.handleResize();
			},
			load: function(scaleParamsJSON) {
				this.scaleParams = JSON.parse(scaleParamsJSON);
			}

		};

		return ScaleManager;
	});

